type CalendarDeliveryIssue = {
  method?: string;
  reason?: string;
  recipients?: string[];
  rejected?: string[];
  status?: string;
};

export const calendarDeliveryIssueText = (issues: CalendarDeliveryIssue[]) => {
  const recipients = [
    ...new Set(
      issues.flatMap(issue =>
        [...(issue.rejected ?? []), ...(issue.recipients ?? [])].filter(Boolean)
      )
    ),
  ];
  const reasons = [
    ...new Set(issues.map(issue => issue.reason).filter(Boolean)),
  ];
  return [
    'Mail delivery issue',
    recipients.join(', '),
    reasons.map(formatCalendarDeliveryReason).join(', '),
  ]
    .filter(Boolean)
    .join(' · ');
};

export const formatCalendarDeliveryReason = (reason: string | undefined) => {
  if (reason === 'credential_unavailable') return 'credential unavailable';
  if (reason === 'mail_account_ineligible') return 'mail account ineligible';
  if (reason === 'mail_account_missing') return 'mail account missing';
  if (reason === 'mail_send_failed') return 'send failed';
  if (reason === 'recipient_rejected') return 'recipient rejected';
  return 'calendar mail issue';
};
